module.exports = __webpack_public_path__ + "static/img/projectI2.0fec58b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/projectI2.png
// module id = Fqyv
// module chunks = 0